import type { inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from 'config-hub-server/src/router/index.js';

/** One row of `environments.list` — the shape the push modal's risk rule and its checklist read. */
export type EnvironmentRow = inferRouterOutputs<AppRouter>['environments']['list'][number];

/** Production or regulated: the push modal's red banner and the confirm it guards. */
export const isRiskyEnvironment = (labels: EnvironmentRow['labels']): boolean =>
    labels.tier === 'prod' || labels.reg === 'true';

/** The ticked environments that are risky, in `environments`' own order — the modal's `Production: …` line. */
export const riskyTicked = (environments: readonly EnvironmentRow[], ticked: ReadonlySet<string>): string[] =>
    environments.filter((e) => ticked.has(e.name) && isRiskyEnvironment(e.labels)).map((e) => e.name);
